'use client'

import getAccountOption from '@/navigation/CSR/goToAccount/getAccountOption'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

export default async function goToAccount(
  router: AppRouterInstance,
  action: string
) {
  const { push } = router
  const pathByAction = getAccountOption(action)
  push(pathByAction)
}
